import { render, staticRenderFns } from "./editUserProfileForm.vue?vue&type=template&id=6dd16b70"
import script from "./editUserProfileForm.vue?vue&type=script&lang=js"
export * from "./editUserProfileForm.vue?vue&type=script&lang=js"
import style0 from "./editUserProfileForm.vue?vue&type=style&index=0&id=6dd16b70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports